module.exports = __webpack_public_path__ + "img/title-dver-2-t@3x.876b60e4.png";